document.addEventListener('DOMContentLoaded', function () {
  var languages = [
    { lang: "French", happiness: "Bonheur", health: "Santé", love: "Amour" },
    { lang: "German", happiness: "Glück", health: "Gesundheit", love: "Liebe" },
    { lang: "Italian", happiness: "Felicità", health: "Salute", love: "Amore" },
    { lang: "Spanish", happiness: "Felicidad", health: "Salud", love: "Amor" },
    { lang: "Portuguese", happiness: "Felicidade", health: "Saúde", love: "Amor" },
    { lang: "Turkish", happiness: "Mutluluk", health: "Sağlık", love: "Sevgi" },
    { lang: "Russian", happiness: "Счастье", health: "Здоровье", love: "Любовь" },
    { lang: "Greek", happiness: "Ευτυχία", health: "Υγεία", love: "Αγάπη" },
    { lang: "Finnish", happiness: "Onni", health: "Terveys", love: "Rakkaus" },
    { lang: "Hungarian", happiness: "Boldogság", health: "Egészség", love: "Szeretet" },
    { lang: "Polish", happiness: "Szczęście", health: "Zdrowie", love: "Miłość" },
    { lang: "Czech", happiness: "Štěstí", health: "Zdraví", love: "Láska" },
    { lang: "Slovenian", happiness: "Sreča", health: "Zdravje", love: "Ljubezen" },
    { lang: "Swedish", happiness: "Lycka", health: "Hälsa", love: "Kärlek" },
    { lang: "Danish", happiness: "Lykke", health: "Sundhed", love: "Kærlighed" },
    { lang: "Dutch", happiness: "Geluk", health: "Gezondheid", love: "Liefde" },
    { lang: "Korean", happiness: "행복", health: "건강", love: "사랑" },
    { lang: "Chinese", happiness: "幸福", health: "健康", love: "爱" },
    { lang: "Arabic", happiness: "سعادة", health: "صحة", love: "حب", rtl: true },
    { lang: "Hindi", happiness: "खुशी", health: "स्वास्थ्य", love: "प्यार" },
    { lang: "Romanian", happiness: "Fericire", health: "Sănătate", love: "Dragoste" },
    { lang: "Albanian", happiness: "Lumturi", health: "Shëndet", love: "Dashuri" },
    { lang: "Norwegian", happiness: "Lykke", health: "Helse", love: "Kjærlighet" },
    { lang: "Indonesian", happiness: "Kebahagiaan", health: "Kesehatan", love: "Cinta" },
    { lang: "Catalan", happiness: "Felicitat", health: "Salut", love: "Amor" },
    { lang: "Latin", happiness: "Felicitas", health: "Sanitas", love: "Amor" },
    { lang: "Estonian", happiness: "Õnn", health: "Tervis", love: "Armastus" },
    { lang: "Latvian", happiness: "Laime", health: "Veselība", love: "Mīlestība" },
    { lang: "Lithuanian", happiness: "Laimė", health: "Sveikata", love: "Meilė" },
    { lang: "Vietnamese", happiness: "Hạnh phúc", health: "Sức khỏe", love: "Tình yêu" },
    { lang: "Hebrew", happiness: "אושר", health: "בריאות", love: "אהבה", rtl: true },
    { lang: "Japanese", happiness: "幸せ", health: "健康", love: "愛" },
    { lang: "Persian", happiness: "خوشبختی", health: "سلامتی", love: "عشق", rtl: true },
    { lang: "Ukrainian", happiness: "Щастя", health: "Здоров'я", love: "Любов" },
    { lang: "Bulgarian", happiness: "Щастие", health: "Здраве", love: "Любов" },
    { lang: "Slovak", happiness: "Šťastie", health: "Zdravie", love: "Láska" },
    { lang: "Icelandic", happiness: "Hamingja", health: "Heilsa", love: "Ást" },
    { lang: "Irish", happiness: "Sonas", health: "Sláinte", love: "Grá" },
    { lang: "Malay", happiness: "Kebahagiaan", health: "Kesihatan", love: "Cinta" },
    { lang: "Thai", happiness: "ความสุข", health: "สุขภาพ", love: "ความรัก" }
  ];

  function initShowcase(section) {
    var grid = section.querySelector('.language-showcase__grid');
    if (!grid) return;
    var state = { category: 'happiness', side: 'a' };

    function render() {
      var start = state.side === 'a' ? 0 : 20;
      var slice = languages.slice(start, start + 20);
      grid.innerHTML = slice.map(function (item) {
        var dir = item.rtl ? ' dir="rtl"' : '';
        return (
          '<div class="language-showcase__item">' +
            '<p class="language-showcase__word"' + dir + '>' + item[state.category] + '</p>' +
            '<p class="language-showcase__label">' + item.lang.toUpperCase() + '</p>' +
          '</div>'
        );
      }).join('');
    }

    section.querySelectorAll('.language-showcase__tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        section.querySelectorAll('.language-showcase__tab').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        state.category = btn.dataset.category;
        render();
      });
    });

    section.querySelectorAll('.language-showcase__side').forEach(function (btn) {
      btn.addEventListener('click', function () {
        section.querySelectorAll('.language-showcase__side').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        state.side = btn.dataset.side;
        render();
      });
    });

    render();
  }

  document.querySelectorAll('.language-showcase').forEach(initShowcase);
});